<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Users Attended The Test">
        <br />
        <div
          class="text-right"
          v-if="
            users.length > 0 &&
              $store.getters.userDetails.includes('CAN_EXPORT_TEST_REPORT')
          "
        >
          <b-button
            variant="success"
            style="margin-right: 10px;"
            @click="exportsubDataDetailed()"
            >Detailed Report</b-button
          >
          <b-button
            variant="success"
            @click="
              $route.params.type == 'subscription'
                ? exportsubData()
                : exportData()
            "
            >Export</b-button
          >
        </div>
        <br />
        <b-table-simple
          responsive
          bordered
          striped
          table-class="table-vcenter"
          v-if="users.length > 0"
        >
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">User Name</b-th>
              <b-th class="text-center">Correct Answers</b-th>
              <b-th class="text-center">Incorrect Answers</b-th>
              <b-th class="text-center">Un Attempted</b-th>
              <b-th class="text-center">Percentage</b-th>
              <b-th class="text-center">Score</b-th>
              <b-th class="text-center">Rank</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(user, index) in users" :key="index">
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
              <b-td class="text-center">
                {{ user.user ? user.user.name : "-" }}
              </b-td>
              <b-td class="text-center">
                {{ user.total_correct_answer }}
              </b-td>
              <b-td class="text-center">
                {{ user.total_incorrect_answer }}
              </b-td>
              <b-td class="text-center">
                {{ user.total_unattempted }}
              </b-td>
              <b-td class="text-center">
                {{ user.pass_percentage }}
              </b-td>
              <b-td class="text-center">
                {{ user.score }}
              </b-td>
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      users: [],
    };
  },
  mounted() {
    if (this.$route.params.type == "subscription") {
      this.getUserAttended();
    } else {
      this.getUserReports();
    }
    
  },
  methods: {
    async exportsubData() {
      alert("subscription");
      if (this.users[0].test_type == "subscription_mock_test") {
        this.type = "mock_test";
      } else {
        this.type = "practice_test";
      }
      //
      await axios
        .get(
          `${this.$store.getters.baseUrl}/sub-userExcel/${this.users[0].subscription_id}/${this.$route.params.id}/${this.type}
`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          // const url = URL.createObjectURL(
          //   new Blob([response.data], {
          //     type: "application/vnd.ms-excel",
          //   })
          // );
          const link = document.createElement("a");
          link.href = response.data.url;
          console.log(response.data.url);
          link.setAttribute("download", "");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async exportsubDataDetailed() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/export-student-records/${this.users[0].subscription_id}/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          // const url = URL.createObjectURL(
          //   new Blob([response.data], {
          //     type: "application/vnd.ms-excel",
          //   })
          // );
          const link = document.createElement("a");
          link.href = response.data.url;
          console.log(response.data.url);
          link.setAttribute("download", "");
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },



    async exportData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/tests-reports/${this.$route.params.date}/${this.$route.params.type}/${this.$route.params.id}
`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status == "success") {
            const link = document.createElement("a");
            link.href = response.data.download_link;
            link.setAttribute("download", "");
            document.body.appendChild(link);
            link.click();
            this.$swal(
              "Success",
              "Test report exported successfully",
              "success"
            );
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getUserReports() {
      const formdata = new FormData();
      formdata.append("test_id", this.$route.params.id);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/all-test-reports
`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.users = response.data.reports;
            if (!this.users.length > 0) {
              this.$swal({
                title: "Info",
                text: "No students have attended the test yet",
                icon: "warning",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router.push({ name: "All Test Reports" });
                } else {
                  this.$router.push({ name: "All Test Reports" });
                }
              });
            }
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getUserAttended() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/sub-user-reports/${this.$route.params.id}
`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.users = response.data.user_tests;
            /*if (!this.users.length > 0) {
              this.$swal({
                title: "Info",
                text: "No students have attended the test yet",
                icon: "warning",
              }).then((result) => {
                if (result.isConfirmed) {
<<<<<<< HEAD
                  this.$router.push({name:"All Test Report" });
                } else {
                  this.$router.push({name:"All Test Report" });
=======
                  this.$router.push({ name: "College All Test Report" });
                } else {
                  this.$router.push({ name: "College All Test Report" });
>>>>>>> feature/organization
                }
              });
            }*/
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
